import CashOnlySVG from "@design-system/ui-icons/vanilla/CashOnly"
import { createIcon } from "../createIcon"

export const CashOnlyIcon = createIcon(CashOnlySVG)
